var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('header-banner',{attrs:{"title":"お役立ちコラム"}}),_vm._v(" "),_c('div',{staticClass:"news-contents"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"news-content"},[_c('div',{staticClass:"news-date"},[_vm._v("■ "+_vm._s(item.date))]),_vm._v(" "),_c('div',{staticClass:"news-title"},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.body)}}),_vm._v(" "),_c('router-link',{attrs:{"to":item.industryId
            ? {
                name: 'Industry',
                params: {
                  no: item.industryId,
                },
              }
            : {
                name: 'Column',
                params: {
                  no: item.no,
                },
              }}},[_vm._v("\n        詳しくはこちら\n      ")])],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4edb903a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Columns.vue
// module id = null
// module chunks = 